import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "padding-auth-contents" }
const _hoisted_2 = { class: "card-outlined md:py-2 md:px-4" }
const _hoisted_3 = { class: "px-2 mb-2 max-w-md" }
const _hoisted_4 = { class: "w-ful" }
const _hoisted_5 = { class: "text-lg font-bold" }
const _hoisted_6 = { class: "md:py-2 md:px-4" }
const _hoisted_7 = { class: "flex items-center justify-between border-gray-300 border-b px-2 mb-2" }
const _hoisted_8 = { class: "text-green-600 hover:text-green-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.qa_categories)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "text-title-underline" }, "過去の質疑応答（テキスト）", -1)),
                  _cache[1] || (_cache[1] = _createElementVNode("p", null, "過去にあった会員さんからのご質問と山根先生の回答をまとめています。", -1)),
                  _cache[2] || (_cache[2] = _createElementVNode("p", null, "講座やワークでつまづいた時は、ぜひ参考になさってみてください。", -1)),
                  _cache[3] || (_cache[3] = _createElementVNode("p", null, "下記をクリックすると、カテゴリごとのQ&A一覧が表示されます。", -1)),
                  _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mt-5 font-bold text-gray-500 mb-2" }, "カテゴリ一覧", -1)),
                  _createElementVNode("ul", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qa_categories, (qa_category) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: qa_category.id,
                        class: "px-1 pt-1.5 pb-2"
                      }, [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(qa_category.name), 1),
                            _createElementVNode("ul", _hoisted_6, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qa_category.qa_sub_categories, (qa_sub_category) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: qa_sub_category.id,
                                  class: "px-1 pt-1.5 pb-2"
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: `/qa/category/`+ qa_sub_category.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, _toDisplayString(qa_sub_category.name), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" ページが見つかりませんでした。 ")
                ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}